

export const TXT_ERROR_INTERNAL_MESSAGE = 'Oops! Have some problems. Please try later.',
    TXT_SUCCESS_SUBMIT_FORM = 'Thank for your submission',
    TXT_ERROR_DOMAIN_NOT_ALLOWED = 'Domain not allowed',
    TXT_FORM_ENDED = 'Form ended',
    TXT_FORM_NOT_STARTED_YET = 'The form has not started yet'
